<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="replaceSubscription()"
    >
      <header class="m-the-modal-header">
        <h5> {{ $t('mEditionBillingMyShoppingChangePlanModalPayMethods.header.title') }} </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p
          v-for="pasarela in gateways"
          :key="pasarela.id_academia_pasarela_pago"
          class="margin-bottom-large margin-top-large"
        >
          <label :class="inputRadioClass">
            <input
              class="a-radiobutton-primary"
              v-model="$modal.element.pasarela"
              name="medioPago"
              type="radio"
              :value="pasarela.id_academia_pasarela_pago"
            >
            <span class="a-radiobutton-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ pasarela.descripcion }}
            </span>
            <span class="margin-left-auto">
              <img
                :alt="findGatewayById(pasarela.pasarela_pago).nombre"
                :src="require(`@/assets/img/gateways/${findGatewayById(pasarela.pasarela_pago).nombre.toLowerCase().replace(' ', '')}.png`)"
              >
            </span>
          </label>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingMyShoppingChangePlanModalPayMethods.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingMyShoppingChangeModalPayMethods',

  data () {
    return {
      buttonPrimary: {
        action: 'Confirmar',
        class: '',
        sending: false,
        type: 'submit'
      },
      inputRadioClass: '',
      pasarelas: [],
      pasarelaSelected: null,
      showLoadingState: 0
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    },

    gateways () {
      return [...this.$modal.element.gateways]
    }
  },

  created () {
    if (this.academyDataColor) {
      this.buttonPrimary.class = 'a-button-academy-primary'
      this.inputRadioClass = 'display-flex-row a-radiobutton-primary a-radiobutton-academy-primary width-100-pr'
    } else {
      this.buttonPrimary.class = 'a-button-billing-primary'
      this.inputRadioClass = 'display-flex-row a-radiobutton-primary a-radiobutton-billing-primary width-100-pr'
    }
    this.readPasarelas()
  },

  methods: {
    replaceSubscription () {
      this.buttonPrimary.sending = true
      this.$services.create('ventas', 'replaceSubscription', Object.assign(
        {},
        { plan: this.$modal.element.plan },
        { pasarela: this.$modal.element.pasarela }), [ this.$store.getters.getAcademyData.id, this.$modal.element.venta ])
        .then(response => {
          this.$utils.isUrl(response.data)
            ? window.location.replace(response.data)
            : this.findGatewayById(this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).pasarela_pago).nombre === 'Paypal'
              ? this.$paypal.formPaypal(JSON.parse(response.data))
              : this.$stripe.init(Object.assign(
                {},
                { stripeAccount: this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).configuracion['id'] },
                { sessionId: response.data })
              )
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
          this.showLoadingState++
        })
        .catch(error => {
          this.showLoadingState++
          this.$alerts.pushAlert('mEditionBillingMyShoppingChangePlanModalPayMethods', 'changePlan', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
          console.log(error)
        })
    },

    findGatewayById (id) {
      return this.pasarelas.find(gw => gw.id === id)
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.pasarelaSelected = this.$modal.element.pasarela
            ? this.pasarelas.find(p => { return p.nombre === this.$modal.element.pasarela }).id
            : null
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
